<template>
  <div id="practiceContainer" class="yxtbiz-practice bg-white pr">
    <template v-if="info">
      <div class="yxtbiz-practice__title" v-if="currentQues">
        <div class="clearfix">
          <span class="yxtbiz-practice__title--left">{{ generateQuesTitle(currentQues.parent?currentQues.parent.quesType:currentQues.quesType) }}<span class="ml16">{{ `${this.index + 1}/${this.allQuestions.length}` }}</span></span>
          <span class="yxtbiz-practice__title--right" v-if="canSkip" @click="doSkip">{{ $t('pc_biz_ote_btn_skip') }}</span>
        </div>
      </div>
      <!-- 作答区 -->
      <div v-if="currentQues" class="yxtbiz-practice__content">
        <yxt-scrollbar :fit-height="true">
          <!-- 组合题题干 -->
          <user-pra-ques-detail v-if="currentQues.parent"
                                practice
                                class="mv24 ph24"
                                :value="currentQues.parent"/>
          <!-- 试题 -->
          <div class="ph24">
            <!-- 单题展示 -->
            <user-pra-ques-detail ref="quesMain"
                                  v-model="currentQues"
                                  practice
                                  :class="'mt24'"
                                  :index='index'
                                  :allowUpload="0"
                                  @submitSingle="doSingle"/>
          </div>
          <div class="yxtbiz-practice__divider">
            <yxtf-divider></yxtf-divider>
          </div>
          <!-- 答案展示 -->
          <div v-if="currentQues.isSubmited && info.allowViewSingleQuesResult" class="yxtbiz-practice__result font-size-14 color-gray-9">
            <!-- 关键词 -->
            <div v-if="currentQues.quesType === 4 && currentQues.resultInfo.keywords && currentQues.resultInfo.keywords.length" class="yxtbiz-practice__result-line">
              <yxtf-tag size="mini" class="yxtbiz-practice__result-line-left">{{ $t('pc_biz_ote_keyword') }}</yxtf-tag>
              <div class="yxtbiz-practice__result-line-right">
                {{ currentQues.resultInfo.keywords.map(item => item.name).join(';') }}
              </div>
            </div>
            <!-- 用户作答的 -->
            <div class="yxtbiz-practice__result-line">
              <yxtf-tag size="mini" class="yxtbiz-practice__result-line-left">{{ $t('pc_biz_ote_lbl_submitanswer') }}</yxtf-tag>
              <!-- 填空题答案 -->
              <div v-if="currentQues.quesType === 3" class="yxtbiz-practice__result-line-right">
                <template v-for="(ans, fillIndex) in currentQues.ansUser">
                  <div :key="'asw' + fillIndex" class="yxtbiz-practice-row-flex">
                    <span class="mr16">{{ `(${fillIndex + 1}) ${ans.answer}` }}</span>
                    <yxt-svg width="16px"
                             height="16px"
                             :remote-url='mediaPath'
                             class="yxtbiz-practice-row-flex__sub"
                             :icon-class="ans.corrected ? 'success' : 'error'"
                             :class="[ans.corrected ? 'yxtf-color-success' : 'yxtf-color-danger']"></yxt-svg>
                  </div>
                </template>
              </div>
              <!-- 其他题型答案 -->
              <div v-else class="yxtbiz-practice__result-line-right yxtbiz-practice-row-flex">
                <span v-if="currentQues.quesType === 4" class="mr16" v-html="currentQues.ansUser" data-rich-text="1"></span>
                <span v-else class="mr16">{{ currentQues.ansUser }}</span>
                <yxt-svg width="16px"
                         height="16px"
                         :remote-url='mediaPath'
                         class="yxtbiz-practice-row-flex__sub"
                         :icon-class="currentQues.resultInfo.corrected ? 'success' : 'error'"
                         :class="[currentQues.resultInfo.corrected ? 'yxtf-color-success' : 'yxtf-color-danger']"></yxt-svg>
              </div>
            </div>
            <!-- 正确答案 -->
            <div v-if="info.allowViewSingleQuesAnswer" class="yxtbiz-practice__result-line">
              <yxtf-tag type="warning" size="mini" class="yxtbiz-practice__result-line-left">{{ $t('pc_biz_ote_lbl_trueanswer') }}</yxtf-tag>
              <div v-if="currentQues.quesType === 3">
                <template v-if="currentQues.ansCorrect.length">
                  <template v-for="(ans, fillIndex) in currentQues.ansCorrect">
                    <div :key="'asw' + fillIndex">
                      ({{ fillIndex + 1 }}) {{ ans }}
                    </div>
                  </template>
                </template>
                <template v-else>{{ $t('pc_biz_ote_lbl_none') }}</template>
              </div>
              <div v-else-if="currentQues.quesType === 4">
                <template v-if='currentQues.ansCorrect || currentQues.resultInfo.answerPlay'>
                  <div v-if="cleanStyle(currentQues.ansCorrect)" class="yxtbiz-practice__result-line-right" v-html="cleanStyle(currentQues.ansCorrect)" data-rich-text="1"></div>
                  <media-player v-if="currentQues.resultInfo.answerPlay && currentQues.resultInfo.answerPlay.fileId"
                                :key="currentQues.resultInfo.answerPlay.fileId"
                                :type="currentQues.resultInfo.answerPlay.type"
                                :options="playerMediaOptions(currentQues.resultInfo.answerPlay)"
                                :tranStatus="currentQues.resultInfo.answerPlay.tranStatus"></media-player>
                </template>
                <template v-else>{{ $t('pc_biz_ote_lbl_none') }}</template>
              </div>
              <div v-else class="yxtbiz-practice__result-line-right" v-html="cleanStyle(currentQues.ansCorrect || $t('pc_biz_ote_lbl_none'))" data-rich-text="1"></div>
            </div>
            <!-- 解析 -->
            <div v-if="info.allowViewSingleQuesExplain" class="yxtbiz-practice__result-line">
              <yxtf-tag size="mini" class="yxtbiz-practice__result-line-left">{{ $t('pc_biz_ote_lbl_quesdesc') }}</yxtf-tag>
              <div class="yxtbiz-practice__result-line-right">
                <span v-html="cleanStyle(currentQues.resultInfo.explainText) || (!currentQues.resultInfo.explainPlay ? $t('pc_biz_ote_lbl_none') : '')" data-rich-text="1"></span>
                <media-player v-if="currentQues.resultInfo.explainPlay && currentQues.resultInfo.explainPlay.fileId"
                              :key="currentQues.resultInfo.explainPlay.fileId"
                              :type="currentQues.resultInfo.explainPlay.type"
                              :options="playerMediaOptions(currentQues.resultInfo.explainPlay)"
                              :tranStatus="currentQues.resultInfo.explainPlay.tranStatus"></media-player>
              </div>
            </div>
          </div>
          <!-- 确认按钮 -->
          <div class="yxtbiz-practice__btns--confirm">
            <yxtf-button v-if="!currentQues.isSubmited && currentQues.quesType !== 0 && currentQues.quesType !== 2"
                         :disabled="!isAnswered || isSubmiting"
                         type="primary"
                         @click="doSingle(currentQues, true)">
              {{ $t('pc_biz_ote_btn_confirm') }}
            </yxtf-button>
          </div>
        </yxt-scrollbar>
      </div>
      <!-- 上一题下一题 -->
      <div class="yxtbiz-practice__btns">
        <yxtf-button plain
                     size="larger"
                     :disabled="index <= 0 || isSubmiting"
                     @click="goIndex(-1)">
          {{ $t('pc_biz_ote_btn_prevques') }}
        </yxtf-button>
        <yxtf-button :plain="!isLastQues"
                     size="larger"
                     :type="isLastQues?'primary':''"
                     :disabled="isSubmiting || !currentQues.isSubmited || (isConfirmed && isLastQues)"
                     @click="goIndex(1)">
          {{ $t(isLastQues ? 'pc_biz_ote_btn_submit':'pc_biz_ote_btn_nextques') }}
        </yxtf-button>
      </div>
      <!-- 水印 -->
      <yxtbiz-watermark :option="watermarkConfig" v-if="showWatermark" :show="true"/>
    </template>
  </div>
</template>
<script>
import MediaPlayer from './media-player';
import {
  getPraStart,
  getErrorPraStart,
  submitSingleAnswerOfpra,
  submitSingleErrorAnswerOfpra,
  submitPractice,
  submitPracticeHalfway,
  postPracticeTime,
  getOrgWatermarkConfig,
  deleteUserPracticeInfo
} from './service';
import UserPraQuesDetail from './UserPraQuesDetail';
import { convertASCIIForNum, cleanStyle, dealLineFeed, handleError } from './common';
import {
  Dialog,
  FrontTag,
  FrontDivider
} from 'yxt-pc';
const USER_PRACTICE_USED_TIME = 'userPracticeUsedTime';
// import ueImagePreview from '../../question-selector/src/ueImagePreview';
export default {
  components: {
    UserPraQuesDetail,
    YxtDialog: Dialog,
    YxtfTag: FrontTag,
    YxtfDrivider: FrontDivider,
    MediaPlayer
  },
  // mixins: [ueImagePreview],
  name: 'YxtbizPractice',
  name_zh: '课程包里的练习dialog组件',
  props: {
    // 练习关联的id
    praId: {
      type: String,
      default: '',
      desc: '练习关联的id',
      setter: 'StringSetter'
    },
    // 错题模式
    isWrongQuestionMode: {
      type: Boolean,
      default: false,
      desc: '是否开启错题模式',
      setter: 'BooleanSetter'
    },
    // 是否可以跳过
    canSkip: {
      type: Boolean,
      default: true,
      desc: '是否可以跳过',
      setter: 'BooleanSetter'
    },
    // 用户练习ID
    pumId: {
      type: String,
      default: '',
      desc: '用户练习ID',
      setter: 'StringSetter'
    },
    // 链路ID
    trackId: {
      type: String,
      default: '',
      desc: '链路ID',
      setter: 'StringSetter'
    }
  },
  data() {
    return {
      index: 0, // 当前操作的试题编号
      info: null, // 练习信息
      allQuestions: [], // 所有的单题
      currentQues: null, // 当前操作的试题
      // 单题提交请求体
      submitAnswerBody: {
        answers: [],
        isH5Exam: 0
      },
      showWatermark: false,
      watermarkConfig: {
        enabled: 1,
        type: 1,
        opacity: 80,
        text: '',
        fontSize: 30,
        color: '#000'
      },
      // doneConfirm: false, // 答完确认框
      isConfirmed: false, // 是否确认了
      isSubmiting: false, // 单题提交中
      isSubmited: false, // 是否最终提交了
      isFinished: false, // 是否全部答完了
      isAnswered: 0, // 当前题目是否作答了，控制确定按钮
      unsubmittedTime: 0,
      timer: null,
      postTimer: null
    };
  },
  computed: {
    mediaPath() {
      return `${this.$staticBaseUrl}ufd/55a3e0/ote/pc/other/ote/svg`;
    },
    isLastQues() {
      return this.index >= this.allQuestions.length - 1;
    },
    storageKey() {
      const userId = window.localStorage.userId;
      return `${USER_PRACTICE_USED_TIME}_${this.praId}_${userId}`;
    }
  },
  created() {
    this.unsubmittedTime = window.localStorage.getItem(this.storageKey) || 0;
  },
  mounted() {
    this.getUpmInfo();
    // 中途退出处理
    window.addEventListener('beforeunload', this.endPracticeHalfway);
  },
  beforeDestroy() {
    this.clearTimer();
  },
  methods: {
    cleanStyle,
    handleError,
    setTimer() {
      if (!this.timer) {
        this.timer = setInterval(() => {
          this.unsubmittedTime++;
          window.localStorage.setItem(this.storageKey, this.unsubmittedTime);
        }, 1000);
      }
      if (!this.postTimer) {
        this.postTimer = setInterval(() => {
          this.postTime();
          // 手动打点
          window.YxtFeLog && window.YxtFeLog.track('e_heartbeat', { lib: 'js', properties: {} });
        }, 30 * 1000);
      }
    },
    clearTimer() {
      if (this.timer) clearInterval(this.timer);
      if (this.postTimer) clearInterval(this.postTimer);
      this.timer = null;
      this.postTimer = null;
    },
    async postTime() {
      const usedTime = this.unsubmittedTime;
      await postPracticeTime({praId: this.praId, puId: this.info.puId, uniqueId: this.info.uniqueId, usedTime }, this.trackId);
      this.unsubmittedTime = this.unsubmittedTime - usedTime;
      window.localStorage.setItem(this.storageKey, this.unsubmittedTime);
    },
    // 跳过
    doSkip() {
      // 最后题做完了提交
      this.endPractice().then(() => {
        this.$emit('skip', {
          praId: this.info.praId,
          praName: this.info.praName,
          repeated: this.info.repeated
        });
      }).catch((err) => {
        // this.handleError.bind(this)(err);
        this.$emit('error', err);
      });
    },
    // 获取练习信息
    getUpmInfo() {
      const usedTime = this.unsubmittedTime;
      let getFun = this.isWrongQuestionMode ? getErrorPraStart : getPraStart;
      getFun(this.praId, usedTime, this.trackId)
        .then((res) => {
          this.unsubmittedTime = this.unsubmittedTime - usedTime;
          this.setTimer();
          this.isFinished = false;
          this.isConfirmed = false;
          this.index = 0;
          this.info = res;
          this.loadQuesList(res.listQues); // 加载页面试题
          this.currentQues = this.allQuestions[this.index];
          if (res.allowAddWatermark === 1) {
            return getOrgWatermarkConfig()
              .then(config => {
                this.showWatermark = true;
                this.watermarkConfig = config;
              });
          }
        })
        .then(() => {
          this.$emit('success', {
            praId: this.info.praId,
            praName: this.info.praName,
            repeated: this.info.repeated
          });
        })
        .catch((err) => {
          if (['apis.ote.exam.question.change'].includes(err && err.error && err.error.key)) {
            this.$confirm('', this.$t('pc_ote_msg_practicequeschanged') /** 当前练习下的试题已被管理员更新，请重新参与作答 */, {
              showCancelButton: false,
              beforeClose: (action, instance, done) => { (action === 'confirm') && done(); },
              type: 'info'
            }).then(() => {
              // 剩余试题被删除，手动结束
              deleteUserPracticeInfo(this.praId).then(() => {
                this.getUpmInfo();
              }).catch(err => {
                this.handleError.bind(this)(err);
              });
            });
          } else {
            // this.handleError.bind(this)(err);
            this.$emit('error', err);
          }
        });
    },
    // 上一题、下一题、提交
    goIndex(i) {
      if (this.isFinished && this.isLastQues && i > 0) {
        // 最后题做完了提交
        this.endPractice().then(() => {
          this.$emit('complete', {
            praId: this.info.praId,
            praName: this.info.praName,
            repeated: this.info.repeated
          });
        }).catch((err) => {
          // this.handleError.bind(this)(err);
          this.$emit('error', err);
        }).finally(() => {
          this.isConfirmed = true;
        });
      } else {
        // 正常上一题下一题
        this.index += i;
        this.currentQues = this.allQuestions[this.index];
        this.isAnswered = this.getSubmitAnswer(this.currentQues, true);
        this.isSubmited = this.currentQues.isSubmited;
      }
    },
    // 练习做完了
    async endPractice(e) {
      if (this.info) {
        const usedTime = this.unsubmittedTime;
        await submitPractice(this.info.praId, this.info.puId, this.info.uniqueId, usedTime, this.trackId);
        this.unsubmittedTime = this.unsubmittedTime - usedTime;
        window.localStorage.setItem(this.storageKey, this.unsubmittedTime);
      }
    },
    // 练习做完了（中途）
    async endPracticeHalfway(e) {
      if (this.info) {
        const usedTime = this.unsubmittedTime;
        await submitPracticeHalfway(this.info.praId, this.info.puId, this.info.uniqueId, usedTime, this.trackId);
        this.unsubmittedTime = this.unsubmittedTime - usedTime;
        window.localStorage.setItem(this.storageKey, this.unsubmittedTime);
      }
    },
    // 做题
    doSingle(ques, isConfirm) {
      // 做过了不在处理，也不可修改
      if (ques.isAnswered) {
        return ques.isAnswered;
      }
      // 单选多选不需要确认
      if (ques.quesType === 0 || ques.quesType === 2 || isConfirm) {
        if (this.isSubmiting) {
          return;
        }
        // 做了，确认提交
        let answer = this.getSubmitAnswer(ques);
        if (ques.isAnswered) {
          let answerList = [];
          if (answer) {
            answerList.push(answer);
          }
          this.submitAnswerBody.uniqueId = this.info.uniqueId;
          this.submitAnswerBody.pumId = this.info.pumId;
          this.submitAnswerBody.answers = answerList;
          this.submitAnswerBody.isLastQues = this.isLastQues ? 1 : 0;
          this.submitSingle();
          this.$forceUpdate();
          this.$refs.quesMain && this.$refs.quesMain.$forceUpdate();
        }
      } else {
        // 还在做，不提交
        this.isAnswered = this.getSubmitAnswer(ques, true);
        this.$forceUpdate();
        this.$refs.quesMain && this.$refs.quesMain.$forceUpdate();
      }
    },
    // 单题提交
    submitSingle() {
      this.isSubmiting = true;
      let submitFun = this.isWrongQuestionMode
        ? submitSingleErrorAnswerOfpra
        : submitSingleAnswerOfpra;
      submitFun(
        this.info.praId,
        this.isWrongQuestionMode ? this.info.pumId : this.info.puId,
        this.submitAnswerBody,
        this.trackId
      )
        .then((res) => {
          if (res && res.length > 0) {
            this.currentQues.resultInfo = res[0];
            // 重新更新练习控制信息
            this.info.allowViewSingleQuesAnswer = this.currentQues.resultInfo.allowViewSingleQuesAnswer;
            this.info.allowViewSingleQuesExplain = this.currentQues.resultInfo.allowViewSingleQuesExplain;
            this.info.allowViewSingleQuesResult = this.currentQues.resultInfo.allowViewSingleQuesResult;
            // 获取答案、对错信息
            this.getansUser();
          }
          if (this.submitAnswerBody.isLastQues) {
            // 做完了
            this.isFinished = true;
          }
          this.currentQues.isSubmited = true;
        })
        .catch((err) => {
          // this.handleError.bind(this)(err);
          this.$emit('error', err);
          this.currentQues.isSubmited = false;
          this.currentQues.isAnswered = false;
        })
        .finally(() => {
          this.isSubmiting = false;
          this.$forceUpdate();
          this.$refs.quesMain && this.$refs.quesMain.$forceUpdate();
        });
    },
    // 处理显示在页面上的答案
    getansUser() {
      let ansCorrect = ''; // 正确答案
      let ansUser = ''; // 用户作答
      switch (this.currentQues.quesType) {
        case 0:
        case 1:
          // 选择类型的
          this.currentQues.choiceItems.forEach((item, index) => {
            if (
              this.info.allowViewSingleQuesAnswer &&
              this.currentQues.resultInfo.answers
            ) {
              // 正确答案
              this.currentQues.resultInfo.answers.forEach((correct) => {
                if (item.id === correct) {
                  ansCorrect += (ansCorrect && '、') + convertASCIIForNum(index);
                }
              });
            }
            // 当前用户答案
            if (this.currentQues.quesType === 1) {
              // 多选
              this.currentQues.answers.forEach((ua) => {
                if (item.id === ua) {
                  ansUser += (ansUser && '、') + convertASCIIForNum(index);
                }
              });
            } else {
              // 单选
              if (item.id === this.currentQues.answer) {
                ansUser += (ansUser && '、') + convertASCIIForNum(index);
              }
            }
          });
          break;
        case 2:
          // 判断
          if (this.info.allowViewSingleQuesAnswer) {
            // ansCorrect = QUES_JUDGE_CHOICE[this.currentQues.resultInfo.judgeAnswer ? 1 : 0];
            if (this.currentQues.resultInfo.judgeAnswer) {
              ansCorrect = this.currentQues.judgeCorrectOptionContent || this.$t('pc_biz_ote_lbl_wright');
            } else {
              ansCorrect = this.currentQues.judgeWrongOptionContent || this.$t('pc_biz_ote_lbl_wrong');
            }
          }

          // ansUser = QUES_JUDGE_CHOICE[this.currentQues.submitContent === '1' ? 1 : 0];
          if (this.currentQues.submitContent === '1') {
            ansUser = this.currentQues.judgeCorrectOptionContent || this.$t('pc_biz_ote_lbl_wright');
          } else {
            ansUser = this.currentQues.judgeWrongOptionContent || this.$t('pc_biz_ote_lbl_wrong');
          }
          // if (this.info.allowViewSingleQuesAnswer) {
          //   ansCorrect = QUES_JUDGE_CHOICE[this.currentQues.resultInfo.judgeAnswer ? 1 : 0];
          // }
          // ansUser = QUES_JUDGE_CHOICE[this.currentQues.submitContent === '1' ? 1 : 0];
          break;
        case 3:
          // 填空
          ansUser = [];
          ansCorrect = [];
          const { fillinCorrectedInfo, corrected } = this.currentQues.resultInfo;
          // 当前用户答案
          this.currentQues.answers.forEach((ua, index) => {
            ansUser.push({
              answer: ua,
              corrected: corrected || fillinCorrectedInfo && fillinCorrectedInfo[index]
            });
          });
          // 正确答案
          if (
            this.info.allowViewSingleQuesAnswer &&
            this.currentQues.resultInfo.fillinAnswers
          ) {
            this.currentQues.resultInfo.fillinAnswers.forEach((as, i) => {
              ansCorrect.push(this.mergeAnswerFun(as));
            });
          }
          break;
        case 4:
          // 问答
          if (this.info.allowViewSingleQuesAnswer) {
            if (this.currentQues.resultInfo.answers[0]) {
              ansCorrect += cleanStyle(this.currentQues.resultInfo.answers[0], true);
            }
          }
          ansUser = dealLineFeed(this.currentQues.submitContent, true);
          break;
        case 5:
          // 组合题不会提交单题
          break;
        default:
      }
      this.currentQues.ansCorrect = ansCorrect;
      this.currentQues.ansUser = ansUser;
    },
    // // 再练一次
    // doOneMore() {
    //   this.isSubmiting = false;
    //   this.isAnswered = 0;
    //   // this.doneConfirm = false;
    //   this.allQuestions = [];
    //   this.getUpmInfo();
    // },
    // 获取用户作答及单题提交请求体
    getSubmitAnswer(ques, isDoing) {
      let answer = [];
      let answered = 0;
      switch (ques.quesType) {
        case 0:
          answer.push(ques.answer);
          answered = !!ques.answer;
          break;
        case 1:
          answer = ques.answers;
          answered = answer && answer.length > 0 ? 1 : 0;
          break;
        case 2:
          answer.push(ques.submitContent);
          answered = ques.submitContent && ques.submitContent !== '-1';
          break;
        case 3:
          let isAns = 0;
          ques.fillInItems.forEach(function(e) {
            if (e) {
              // 默认存下填空题的所有空（填空题批阅会考虑填空项的顺序）
              answer.push(e.submitAnswer ? e.submitAnswer : '');
              if (e.submitAnswer && e.submitAnswer.length > 0) {
                isAns = 1;
              }
            }
          });
          // 如果一个空都没有填，把answer置空
          if (isAns !== 1) {
            answer = [];
          }
          answered = isAns;
          ques.answers = answer;
          break;
        case 4:
          // 问答题答案
          answer.push(ques.submitContent);
          answered = ques.submitContent ? 1 : 0;
          break;
        default:
          break;
      }
      if (isDoing) {
        // 作答中只返回是否已做答
        return answered;
      } else {
        ques.isAnswered = answered;
      }
      // 组装单体提交请求体
      let answerBody = {};
      answerBody.quesId = ques.id;
      answerBody.lastSubmitTime = new Date().getTime();
      answerBody.answer = answer;
      answerBody.examQuesId = ques.examQuesId;
      answerBody.quesType = ques.quesType;
      return answerBody;
    },
    // 加载各题型试题（并判断试题是否已作答）
    loadQuesList(quesList) {
      for (let i = 0; i < quesList.length; i++) {
        const e = quesList[i];
        e.type = e.quesType;
        switch (e.quesType) {
          case 0:
          case 1:
          case 2:
          case 3:
          case 4:
            this.dealQuestionInfo(e);
            break;
          case 5:
            // 处理子题
            if (e.subQuesList && e.subQuesList.length > 0) {
              e.subQuesList.forEach((ques) => {
                ques.type = ques.quesType;
                this.dealQuestionInfo(ques, e);
              });
            }
            break;
          default:
            break;
        }
      }
    },
    // 处理服务器给的题目信息
    dealQuestionInfo(ques, pQues) {
      switch (ques.quesType) {
        case 0:
          ques.answer = '';
          break;
        case 1:
          ques.answers = [];
          break;
        case 2:
          ques.submitContent = '';
          break;
        case 3:
        case 4:
          break;
        default:
          break;
      }
      ques.isAnswered = 0;
      if (pQues) {
        ques.parent = pQues;
      }
      this.allQuestions.push(ques);
    },
    // 生成试卷题型标题
    generateQuesTitle(type) {
      return this.$t('pc_biz_ote_lbl_questype' + type);
    },
    playerMediaOptions(mediaPlay) {
      if (mediaPlay.tranStatus === 2) {
        const options = mediaPlay.playDetails;
        return options.map(option => {
          return {
            fileFullUrl: option.url,
            fileId: mediaPlay.fileId,
            resolution: option.desc
          };
        });
      }
      return [{
        fileFullUrl: '',
        label: ''
      }];
    },
    // 合并填空题-answer的备选答案
    mergeAnswerFun(item) {
      const { itemAnswer, itemAnswer1, itemAnswer2, itemAnswer3, itemAnswer4, itemAnswer5 } = item;
      return [itemAnswer, itemAnswer1, itemAnswer2, itemAnswer3, itemAnswer4, itemAnswer5].filter(item => item && item.trim() !== '').join(';');
    }
  },
  beforeRouteLeave(to, from, next) {
    this.endPracticeHalfway();
    window.removeEventListener('beforeunload', this.endPracticeHalfway);
    next();
  }
};
</script>
